import React, { useMemo, useState } from "react";
import { Button, Tooltip } from "@mui/material";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { copyUrl, isIframe } from "./carouselHelpers";

const CopyIframeUrlButton: React.FC = () => {
  const [copied, setCopied] = useState(false);

  // Determine if we’re in an iframe mode automatically
  const isIframeMode = useMemo(() => isIframe(), []);

  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    copyUrl(setCopied);
  };

  // Don’t render anything unless we’re in iframe mode
  if (!isIframeMode) return null;

  return (
    <Tooltip title={copied ? "Copied!" : "Copy iFrame link"}>
      <Button
        data-cy="carousel-copy-iframe-btn"
        onClick={handleCopy}
        size="small"
        variant="contained"
        sx={{
          minWidth: 40,
          padding: "6px",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.8)",
          },
        }}
      >
        <InsertLinkIcon fontSize="small" />
      </Button>
    </Tooltip>
  );
};

export default CopyIframeUrlButton;
